import { AppShell, Group, SegmentedControl, Text } from "@mantine/core";

export type Tab =
  | "signups"
  | "accounts"
  | "certs"
  | "expiring"
  | "pending"
  | "alerts"
  | "audit"
  | "health";

export function TopBar({
  tab,
  onTabChange,
}: {
  tab: Tab;
  onTabChange: (t: Tab) => void;
}) {
  return (
    <AppShell.Header>
      <Group h="100%" px="md" justify="space-between">
        <Group gap="sm">
          <Text fw={700} size="lg">
            Dovach
          </Text>
          <Text c="dimmed" size="sm">
            Operator Admin
          </Text>
        </Group>
        <SegmentedControl
          value={tab}
          onChange={(v) => onTabChange(v as Tab)}
          data={[
            { value: "signups", label: "Signups" },
            { value: "accounts", label: "Accounts" },
            { value: "certs", label: "Recent certs" },
            { value: "expiring", label: "Expiring" },
            { value: "pending", label: "Pending" },
            { value: "alerts", label: "Alerts" },
            { value: "audit", label: "Audit" },
            { value: "health", label: "Health" },
          ]}
        />
      </Group>
    </AppShell.Header>
  );
}
